// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import api from './http'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import axios from '@/http/axios'
import Qs from "qs"
import store from './store/store'
// import 'lib-flexible/flexible.js'
Vue.prototype.$axios = axios
Vue.prototype.$store = store
Vue.prototype.Qs = Qs
Vue.use(ElementUI)
Vue.use(api)
Vue.config.productionTip = false

Vue.directive('showTips', {
    // el {element} 当前元素
    componentUpdated(el) {
        const curStyle = window.getComputedStyle(el, '') // 获取当前元素的style
        const textSpan = document.createElement('span') // 创建一个容器来记录文字的width
        // 设置新容器的字体样式，确保与当前需要隐藏的样式相同
        textSpan.style.fontSize = curStyle.fontSize
        textSpan.style.fontWeight = curStyle.fontWeight
        textSpan.style.fontFamily = curStyle.fontFamily
        // 将容器插入body，如果不插入，offsetWidth为0
        document.body.appendChild(textSpan)
        // 设置新容器的文字
        textSpan.innerHTML = el.innerText
        // 如果字体元素大于当前元素，则需要隐藏
        if (textSpan.offsetWidth > el.offsetWidth) {
            // 给当前元素设置超出隐藏
            el.style.overflow = 'hidden'
            el.style.textOverflow = 'ellipsis'
            el.style.whiteSpace = 'nowrap'
            // 鼠标移入
            el.onmouseenter = function (e) {
                // 创建浮层元素并设置样式
                const vcTooltipDom = document.createElement('div')
                vcTooltipDom.style.cssText = `
                    max-width:400px;
                    max-height: 400px;
                    overflow: auto;
                    position:absolute;
                    top:${e.clientY + 5}px;
                    left:${e.clientX}px;
                    background: rgba(0, 0 , 0, .6);
                    color:#fff;
                    border-radius:5px;
                    padding:10px;
                    display:inline-block;
                    font-size:12px;
                    z-index:19999
                `
                // 设置id方便寻找
                vcTooltipDom.setAttribute('id', 'vc-tooltip')
                // 将浮层插入到body中
                document.body.appendChild(vcTooltipDom)
                // 浮层中的文字
                document.getElementById('vc-tooltip').innerHTML = el.innerText
            }
            // 鼠标移出
            el.onmouseleave = function () {
                // 找到浮层元素并移出
                const vcTooltipDom = document.getElementById('vc-tooltip')
                vcTooltipDom && document.body.removeChild(vcTooltipDom)
            }
        }
        // 记得移除刚刚创建的记录文字的容器
        document.body.removeChild(textSpan)
    },
    // 指令与元素解绑时
    unbind() {
        // 找到浮层元素并移除
        const vcTooltipDom = document.getElementById('vc-tooltip')
        vcTooltipDom && document.body.removeChild(vcTooltipDom)
    }
})


const originalPush = router.__proto__.push
router.__proto__.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
}
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    console.log('tag', to.path)
    if (to.path === '/') {
        store.commit("setistab", 0);
    }
    if (to.path === '/class') {
        store.commit("setistab", 1);
    }
    if (to.path === '/shopcar') {
        store.commit("setistab", 2);
    }
    if (to.path === '/order') {
        store.commit("setistab", 3);
    }
    // 登录界面登录成功之后，会把用户信息保存在会话
    // 存在时间为会话生命周期，页面关闭即失效。
    let token = localStorage.getItem("lw_token")
    // next()
    // if (to.meta.logins) {
    //   next({ path: '/register' })
    // }

    if (to.path === '/login') {
        // 如果是访问登录界面，如果用户会话信息存在，代表已登录过，跳转到主页
        if (token) {
            next({ path: '/' })
        } else {
            next()
        }
    } else {
        // next()
        if (!token && !to.meta.logins) {
            // 如果访问非登录界面，且户会话信息不存在，代表未登录，则跳转到登录界面
            next({ path: '/login' })
        } else {
            // 加载动态菜单和路由
            // addDynamicMenuAndRoutes(userName, to, from)
            next()
        }
    }
})
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js